import React from "react";
import {Paths} from "../../app/components/sidebar/Paths";
import LinkComponent, {ALinkTarget} from "../../app/components/link/LinkComponent";
import {ScreenComponent} from "../../app/components/screen/ScreenComponent";
import {GradientHeaderComponent} from "../../app/components/gradientheader/GradientHeaderComponent";
import {H3SectionComponent} from "../../app/components/section/SectionComponent";

export default function ITTeamMatchingScreen() {
    return (<ScreenComponent>
        <Header/>
        <BeNice/>
        <HiringManagers/>
        <InterviewNowadays/>
        <Luck/>
    </ScreenComponent>)
}

function Header() {
    return (<GradientHeaderComponent title={Paths.interviewTips.nested.teamMatching.name}/>)
}

function BeNice() {
    return (<H3SectionComponent header="Be nice to recruiters.">
        <p>See <LinkComponent link={Paths.interviewTips.nested.recruiters.path} target={ALinkTarget.internal}>Recruiters
            Tips & Tricks</LinkComponent>.</p>
    </H3SectionComponent>)
}

function HiringManagers() {
    return (<H3SectionComponent header="Prepare to meet with hiring managers.">
        <p>Similarly to preparing to meet with recruiters, you should also think about your meetings with hiring
            managers, or HMs. This stage is all about finding out if this team is a good fit for you, and you are a
            good fit for them. What a good team for you looks like may be different than someone else. Think about
            what you need to thrive at work. You generally want to come up with questions for the HM that will help
            you figure out if the team is a good match for you or not.</p>
        <ul>
            <li>Maybe if being in the same office is important to you, you'd ask something like, "Is the team all
                located in City X?"
            </li>
            <li>Or if releasing products into the world is important you may ask something like, "How often do you
                guys release updates?"
            </li>
            <li>If you are motivated by promotions / title changes, you may be thinking about, "What are the growth
                opportunities you see for this position?"
            </li>
            <li>Nowadays, as the power is very much in employers hands, I would stay away from questions like, "What
                is the work life balance", "What is the tech stack", etc. unless those things are truly a
                make-or-break for you.
            </li>
        </ul>
    </H3SectionComponent>)
}

function InterviewNowadays() {
    return (<H3SectionComponent header="It's not another interview, but it also kind of is nowadays.">
        <p>There are way more people in team matching than it seems there are job openings. I've seen some people go
            from passing to match in 3 days, I've seen others go for 8+ months. You are competing against others,
            don't be rude. Ask good questions, be genuinely interested in the role. Take the first one you are even
            somewhat interested in.</p>
    </H3SectionComponent>)
}

function Luck() {
    return (<H3SectionComponent header="There is an element of luck to it no matter what you do.">
        <p>We don't know what goes on behind the scenes. It could be that the person needs someone immediately - so
            they are only looking at candidates who already live in the area. Or maybe they do this one very
            specific thing in Rust, so they are only looking for people who mentioned that specific thing on their
            resume, etc. Embrace the craziness that is, try to find others in the same boat as you so you can
            laugh-cry about it all. Breathe in, breathe out, it will be okay.</p>
    </H3SectionComponent>)
}
